// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.field-row{display:flex;margin:0 -0.75rem 1rem -0.75rem}`, "",{"version":3,"sources":["webpack://./src/common/components/Form/FieldRow/FieldRow.scss"],"names":[],"mappings":"AAAA,WACE,YAAA,CACA,+BAAA","sourcesContent":[".field-row {\n  display: flex;\n  margin: 0 -0.75rem 1rem -0.75rem;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
